import { GetNextPageParamFunction } from 'react-query';
import { IPagination } from 'types/pagination.types';

export function checkHasMore(pagination: IPagination) {
  return pagination.total > pagination.current * pagination.pageSize;
}

export const getNextPageParam: GetNextPageParamFunction<
  Record<any, any> & { pagination: IPagination }
> = (lastPage) => {
  const pagination = lastPage.pagination;
  return checkHasMore(pagination) ? pagination.current + 1 : undefined;
};
